(() => {
  const bundle = document.querySelector('product-bundle[data-pembree-cockpit-bundle]');
  if (!bundle || bundle.dataset.pembreeCompatibilityReady === 'true') return;

  bundle.dataset.pembreeCompatibilityReady = 'true';

  const stemHandle = 'gcs-mountain-bike-stem';
  const barHandle = 'gcs-mountain-bike-handlebars';
  const status = document.querySelector('[data-pembree-diameter-status]');
  let synchronising = false;

  const normaliseDiameter = (value = '') => {
    const normalised = String(value).replace(',', '.').trim();
    if (/31\.8/.test(normalised)) return '31.8';
    if (/\b35(?:\.0)?\b/.test(normalised)) return '35';
    return null;
  };

  const productCard = (handle) => document.querySelector(`[data-product-handle="${handle}"]`);

  const diameterInputs = (card) => {
    if (!card) return [];
    return Array.from(card.querySelectorAll('input[type="radio"][data-option-value]'))
      .filter((input) => normaliseDiameter(input.value));
  };

  const selectedDiameter = (card) => {
    const selected = diameterInputs(card).find((input) => input.checked);
    return selected ? normaliseDiameter(selected.value) : null;
  };

  const showStatus = (message, isError = false) => {
    if (status) {
      status.innerHTML = `<strong>${isError ? 'Check compatibility:' : 'Compatibility matched:'}</strong> ${message}`;
      status.style.borderColor = isError ? 'currentColor' : '';
    }
  };

  const syncDiameter = (sourceInput) => {
    if (synchronising) return;

    const sourceCard = sourceInput.closest('[data-product-handle]');
    const sourceHandle = sourceCard?.dataset.productHandle;
    if (![stemHandle, barHandle].includes(sourceHandle)) return;

    const diameter = normaliseDiameter(sourceInput.value);
    if (!diameter) return;

    const targetHandle = sourceHandle === stemHandle ? barHandle : stemHandle;
    const targetCard = productCard(targetHandle);
    const targetInput = diameterInputs(targetCard)
      .find((input) => normaliseDiameter(input.value) === diameter);

    if (!targetInput || targetInput.disabled || targetInput.classList.contains('disabled')) {
      showStatus(`${diameter} mm is not currently available for both the Stem and Handlebars.`, true);
      return;
    }

    synchronising = true;
    if (!targetInput.checked) targetInput.click();
    synchronising = false;
    showStatus(`Stem and Handlebars are both set to ${diameter} mm.`);
  };

  const addedDiameter = (handle) => {
    const item = Array.from(bundle.querySelectorAll('[data-product-bundle-variant]:not([available])'))
      .find((variant) => variant.product?.dataset.productHandle === handle);
    if (!item) return null;

    const optionTexts = Array.from(item.querySelectorAll('li')).map((option) => option.textContent);
    return optionTexts.map(normaliseDiameter).find(Boolean) || null;
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('input[type="radio"][data-option-value]');
    if (!input || !normaliseDiameter(input.value)) return;
    syncDiameter(input);
  }, true);

  document.addEventListener('click', (event) => {
    const submit = event.target.closest('[data-product-bundle-submit]');
    if (!submit || !bundle.contains(submit)) return;

    const stemDiameter = addedDiameter(stemHandle);
    const barDiameter = addedDiameter(barHandle);
    if (!stemDiameter || !barDiameter || stemDiameter === barDiameter) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const message = `The Stem is ${stemDiameter} mm but the Handlebars are ${barDiameter} mm. Remove one of them and select matching diameters.`;
    const error = bundle.querySelector('.product-form__error-message');
    if (error) {
      error.hidden = false;
      error.textContent = message;
    }
    showStatus(message, true);
    status?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);

  const initialDiameter = selectedDiameter(productCard(stemHandle));
  const initialTarget = diameterInputs(productCard(stemHandle))
    .find((input) => normaliseDiameter(input.value) === initialDiameter);
  if (initialTarget) syncDiameter(initialTarget);
})();
